import type { FrontendConfiguration } from '@rover/rsdk/src/apiClient/latest/model/frontendConfiguration';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

export default function fetchFrontendConfigurationResponseFactory(
  opts?: Partial<FrontendConfiguration>
): FrontendConfiguration {
  return {
    flags: {},
    settings: {
      branchKey: '',
      ccTld: '',
      countryCode: '',
      csrfCookieName: '',
      dogSizeBuckets: {
        // We add defaults here because the a11y PR check fails if the labels are blank
        small: '0-15',
        medium: '16-40',
        large: '41-100',
        giant: '101+',
      },
      experimentUserAttributes: {
        userId: 'abc123',
        email: 'test@email.com',
        userAgent: 'fake/user-agent',
        ip: '1.2.3.4',
        country: 'US',
        locale: 'en-US',
        appVersion: '1.0.0',
        custom: {},
        customIds: {
          roverCid: 'rover-cid-123',
          environmentId: 'env-id-456',
        },
      },
      googleMapsClientId: '',
      gtmContainerId: '',
      imageUploadMaxSize: 0,
      isBeforeHoliday: false,
      language: '',
      personReferralAccount: '',
      personReferralCampaign: '',
      priceTransparencyLevel: PriceTransparencyLevels.none,
      staticSvgPresent: '',
      supportsMobileApp: false,
      supportsReferral: false,
      weightUnit: '',
      staticGoogleMapsApiKey: '',
      sessionReplaySampleRate: 0,
    },
    ...opts,
  };
}
